import { Paragraph } from '@zillow/constellation-10';

type Props = {
  outcomeStats: number;
  source: string;
};

const WizardTipContent = ({ outcomeStats, source }: Props) => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph>
        Providing renters with the rental’s square footage can result in up to {outcomeStats}% more contacts, based on
        data for similarly priced listings.
      </Paragraph>

      <Paragraph textStyle="body-xs" color="text.subtle" css={{ marginBlock: '400' }}>
        {source}
      </Paragraph>
    </div>
  );
};

export default WizardTipContent;
